document.addEventListener("DOMContentLoaded", function() {
  var footerLinks = document.querySelectorAll('footer a');
  // normalizziamo anche i testi validi in minuscolo
  var validTexts = ["Privacy settings", "Impostazioni privacy"].map(t => t.toLowerCase());

  footerLinks.forEach(function(link) {
    // testo del link in minuscolo
    var text = link.textContent.trim().toLowerCase();
    if (validTexts.includes(text)) {
      link.classList.add("iubenda-cs-preferences-link");
      link.setAttribute("href", "#");
    }
  });
});
